"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACCOUNT_SETTINGS = void 0;
var ACCOUNT_SETTINGS = {
  BUTTON__LEGAL: 'accountSettings-button-legal',
  BUTTON__HELP: 'accountSettings-button-help',
  BUTTON__SIGN_OUT: 'accountSettings-button-signOut'
};
exports.ACCOUNT_SETTINGS = ACCOUNT_SETTINGS;